<template>
  <div class="paypal-button-render" ref="paypalId"></div>
</template>
<script>
export default {
  // mounted() {
  //   const event = new CustomEvent('customPaypalRender', {
  //     detail: {
  //       target: this.$refs.paypalId,
  //     },
  //   })
  //   document.dispatchEvent(event)
  // },
}
</script>
<style scoped lang='scss'>
  .paypal-button-render {
    position: relative;
    z-index: 1;
  }
</style>